import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';

import IntegrationReactSelect from '../Common/IntegrationReactSelect';
import Progress from '../Common/Progress';
import { commonActions, clientActions } from '../../_actions';
import './TableStyle.css';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    button: {
        margin: theme.spacing.unit,
        marginTop: '20px'
    },
    buttonInside: {
        margin: 20,
        marginTop: 25,
        padding: 1,
    },
    paper: {
        position: 'absolute',
        [theme.breakpoints.down('sm')]: {
            width: '80%',
            height: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
    },
    textFieldRight: {
        width: '65%',
    }
});

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class FormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ClientId: '',
            CompanyName: '',
            Location: '',
            ContactPerson: '',
            MainContact: '',
            moreData: [],

            CompanyNameValid: true,
            LocationValid: true,
            ContactPersonValid: true,
            MainContactValid: true,

            dynamicContactPerson: [],
            dynamicMainContact: [],

            mode: 'ADD',
            modalTitle: 'Create Client',
            openProgress: false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(commonActions.getAll('Location'));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.clientData && nextProps.clientData !== this.props.clientData) {
            this.setState({
                CompanyName: nextProps.clientData.CompanyName,
                Location: nextProps.clientData.Location,
                ContactPerson: nextProps.clientData.ContactPerson,
                MainContact: nextProps.clientData.MainContact,
                ClientId: nextProps.clientData.id,
                moreData: moreDataConvert(nextProps.clientData.MoreData),

                mode: 'EDIT',
                modalTitle: 'Edit Client'
            });

            this.setState({ dynamicContactPerson: moreDataReConvertContactPerson(nextProps.clientData.MoreData) });
            this.setState({ dynamicMainContact: moreDataReConvertMainContact(nextProps.clientData.MoreData) });
        }
    }

    handleClose = () => {
        this.cleanData();
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleSave = () => {
        let TextFieldVaild = true;
        if (this.state.CompanyName === '') {
            this.setState({
                CompanyNameValid: false
            })
            TextFieldVaild = false;
        }
        if (this.state.Location === '') {
            this.setState({
                LocationValid: false
            })
            TextFieldVaild = false;
        }

        const DataProcessing = async () => {
            try {
                this.setState({
                    openProgress: true
                })

                var inputData = {
                    'ClientId': this.state.ClientId,
                    'CompanyName': this.state.CompanyName,
                    'Location': this.state.Location,
                    'ContactPerson': this.state.ContactPerson ? this.state.ContactPerson : '',
                    'MainContact': this.state.MainContact ? this.state.MainContact : '',
                    'MoreData': dynamicTableConvertToJson(this.state.dynamicContactPerson, this.state.dynamicMainContact),
                    'CreatedUserId': this.props.user.id,
                    'UpdatedUserId': this.props.user.id,
                };

                if (this.state.mode === 'ADD') {
                    await this.props.dispatch(clientActions.insert(inputData));
                }
                else if (this.state.mode === 'EDIT') {
                    await this.props.dispatch(clientActions.update(inputData));
                }

                await this.props.dispatch(clientActions.getAll());
                await this.cleanData();

            } catch (e) {
                console.error("Problem", e)
            }
        }

        if (TextFieldVaild) {
            DataProcessing();
        }
    };

    cleanData() {
        this.setState({
            ClientId: '',
            CompanyName: '',
            Location: '',
            ContactPerson: '',
            MainContact: '',
            moreData: [],

            CompanyNameValid: true,
            LocationValid: true,
            ContactPersonValid: true,
            MainContactValid: true,

            dynamicContactPerson: [],
            dynamicMainContact: [],

            mode: 'ADD',
            modalTitle: 'Create Client',
            openProgress: false
        });

        this.props.close();
    }

    handleShareholderNameChange = (idx) => (evt) => {
        const newShareholders = this.state.dynamicContactPerson.map((shareholder, sidx) => {
            if (idx !== sidx) return shareholder;
            return { ...shareholder, name: evt.target.value };
        });

        this.setState({ dynamicContactPerson: newShareholders });
    }

    handleDynamicMainContactChange = (idx) => (evt) => {
        const newShareholders = this.state.dynamicMainContact.map((shareholder, sidx) => {
            if (idx !== sidx) return shareholder;
            return { ...shareholder, name: evt.target.value };
        });

        this.setState({ dynamicMainContact: newShareholders });
    }

    handleAddShareholder = () => {
        this.setState({ dynamicContactPerson: this.state.dynamicContactPerson.concat([{ name: '' }]) });
        this.setState({ dynamicMainContact: this.state.dynamicMainContact.concat([{ name: '' }]) });
    }

    handleRemoveShareholder = (idx) => () => {
        this.setState({ dynamicContactPerson: this.state.dynamicContactPerson.filter((s, sidx) => idx !== sidx) });
        this.setState({ dynamicMainContact: this.state.dynamicMainContact.filter((s, sidx) => idx !== sidx) });
    }

    handleSelectData = (data) => {
        this.setState({
            Location: data.id
        })
    }

    render() {
        const { classes, common } = this.props;

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography id="modal-title" style={{ fontSize: 40 }}>
                            {this.state.modalTitle}
                        </Typography>

                        <Grid container>
                            <Grid item sm={12} md={6}>
                                <TextField
                                    error={!this.state.CompanyNameValid}
                                    id="outlined-name"
                                    label="*Company Name"
                                    className={classes.textField}
                                    value={this.state.CompanyName}
                                    onChange={this.handleChange('CompanyName')}
                                    margin="normal"
                                    variant="outlined"
                                    InputProps={{ inputProps: { tabIndex: 0 } }}
                                />
                                <TextField
                                    id="outlined-name"
                                    label="Contact Person"
                                    className={classes.textField}
                                    value={this.state.ContactPerson}
                                    onChange={this.handleChange('ContactPerson')}
                                    margin="normal"
                                    variant="outlined"
                                    InputProps={{ inputProps: { tabIndex: 2 } }}
                                />
                                {this.state.dynamicContactPerson.map((shareholder, idx) => (
                                    <TextField key={idx}
                                        label="Contact Person"
                                        placeholder={`Contact Person #${idx + 1}`}
                                        value={shareholder.name}
                                        className={classes.textField}
                                        onChange={this.handleShareholderNameChange(idx)}
                                        margin="normal"
                                        variant="outlined"
                                        InputProps={{ inputProps: { tabIndex: `${2 * (idx + 2)}` } }}
                                    />
                                ))}
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <div style={{ marginTop: '16px' }}>
                                    <IntegrationReactSelect
                                        handleSelectData={this.handleSelectData}
                                        options={convertLocationOptions(common.items_location)}
                                        valid={this.state.LocationValid}
                                        value={this.state.Location}
                                        placeholder='*Location' />
                                </div>
                                <TextField
                                    id="outlined-name"
                                    label="Main Contact"
                                    className={classes.textField}
                                    value={this.state.MainContact}
                                    onChange={this.handleChange('MainContact')}
                                    margin="normal"
                                    variant="outlined"
                                    InputProps={{ inputProps: { tabIndex: 3 } }}
                                />
                                {this.state.dynamicMainContact.map((shareholder, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex',
                                        flexWrap: 'wrap'
                                    }}>
                                        <TextField
                                            label="Main Contact"
                                            placeholder={`Main Contact #${idx + 1}`}
                                            value={shareholder.name}
                                            className={classes.textFieldRight}
                                            onChange={this.handleDynamicMainContactChange(idx)}
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{ inputProps: { tabIndex: `${(2 * (idx + 2) + 1)}` } }}
                                        />
                                        <Button color="secondary" variant="outlined" className={classes.buttonInside} onClick={this.handleRemoveShareholder(idx)}>-</Button>
                                    </div>
                                ))}
                            </Grid>
                        </Grid>

                        <Button variant="outlined" className={classes.button} onClick={this.handleAddShareholder}>Add More Contacts</Button>

                        <div style={{ marginTop: '40px' }} />
                        <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave}>
                            Save
                        </Button>
                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

function convertLocationOptions(LocationData) {
    const suggestions = LocationData ? LocationData.map(suggestion => ({
        value: suggestion.DefineValue1,
        label: suggestion.DefineValue2 + ' ' + suggestion.DefineValue3,
        id: suggestion.DefineValue1,
    })) : null;

    return suggestions
}

function moreDataConvert(data) {
    if (data !== null) {
        let ContactsData = data.Contacts.map((data, key) => {
            return {
                id: key,
                mainContact: data.MainContact,
                contactPerson: data.ContactPerson,
            };
        });

        return ContactsData;
    }
    else {
        return [];
    }
}

function moreDataReConvertContactPerson(data) {
    if (data !== null) {
        let ContactsData = data.Contacts.map((data, key) => {
            return {
                name: data.ContactPerson,
            };
        });

        return ContactsData;
    }
    else {
        return [];
    }
}

function moreDataReConvertMainContact(data) {
    if (data !== null) {
        let ContactsData = data.Contacts.map((data, key) => {
            return {
                name: data.MainContact,
            };
        });

        return ContactsData;
    }
    else {
        return [];
    }
}

function dynamicTableConvertToJson(ContactPerson, MainContact) {
    let MoreContactsData = ContactPerson.map((ContactPersonName, ikey) => {
        return {
            "ContactPerson": ContactPersonName.name,
            "MainContact": MainContact[ikey].name
        };
    });

    let jsonData = null;
    if (MoreContactsData.length !== 0) {
        jsonData = {
            "Contacts": MoreContactsData
        }
    }

    return jsonData;
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { clients, common } = state;

    return {
        user,
        clients,
        common
    };
}

FormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(FormComponent);



// WEBPACK FOOTER //
// ./src/components/Clients/FormComponent.js